<template>
	<div class="img-hover">
		<img class="pic-def" :src="src" :width="width"/>
		<div class="hover-cont">
			<img :src="src" />
		</div>
	</div>
</template>

<script>
	/**
	 * z-img-hover
	 * @module components/ImgHover
	 * @param {String} [src] - 图片路径
	 * @param [String,Number] [width] - 图片宽度，默认50px
	 * @example
	 * <z-img-hover :src="item.face" width="80"></z-img-hover>
	 */
	export default {
		name: 'z-img-hover',
		props: {
			src: String,
			width: {
    		type:[String,Number],
				default: '50'
  	  }
		}
	};
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	.img-hover{
		position: relative;
		&:hover{
			.hover-cont{
		        visibility: visible;
		        opacity: 1;
		    }
		}
	}
	.hover-cont {
		position: absolute;
		top: 0;
		left: 110%;
		width: 300px;
		z-index: 9999;
		padding: 5px;
		background: #fff;
		border: 1px solid $color-border;
		transition: all 0.2s ease;
		-webkit-transition: all 0.2s ease;
		visibility: hidden;
		opacity: 0;
		box-shadow: 2px 2px 5px 0 rgba(0,0,0,0.3);
		-webkit-box-shadow: 2px 2px 5px 0 rgba(0,0,0,0.3);
		img {
			width: 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// ImgHover.vue?0d7a7256